import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=5db03f48&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style1 from "./Register.vue?vue&type=style&index=1&id=5db03f48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db03f48",
  null
  
)

export default component.exports